import React from "react";
import SimpleModal from "../../../../UI/Modals/SimpleModal/SimpleModal";
import Button from "../../../../UI/Buttons/Button/Button";
import { PharmacyLicenseResponse } from "../../../../../types/pharmacyLicense";
import styles from "./DeleteConfirmationModal.module.scss";

type Props = {
  show: boolean;
  license: PharmacyLicenseResponse | null;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
};

const DeleteConfirmationModal = ({
  show,
  license,
  onConfirm,
  onCancel,
  loading = false,
}: Props) => {
  if (!show || !license) return null;

  return (
    <SimpleModal show={show} backdropClickHandler={onCancel}>
      <div className={styles.confirmationContent}>
        <h3 className={styles.confirmationTitle}>Potvrda brisanja</h3>
        <p className={styles.confirmationMessage}>
          Da li ste sigurni da želite da obrišete farmaceuta{" "}
          <strong>
            {license.licenseUserFirstName} {license.licenseUserSecondName}
          </strong>{" "}
          (licenca: {license.licenseCode})?
        </p>
        <div className={styles.confirmationButtons}>
          <Button
            buttonType="red"
            onClick={onConfirm}
            disabled={loading}
            className={styles.confirmButton}
          >
            {loading ? "Brisanje..." : "Da, obriši"}
          </Button>
          <Button
            buttonType="white"
            onClick={onCancel}
            disabled={loading}
            className={styles.cancelButton}
          >
            Otkaži
          </Button>
        </div>
      </div>
    </SimpleModal>
  );
};

export default DeleteConfirmationModal;
